import React, { Suspense } from 'react'
import { Outlet } from 'react-router-dom'
import AppLayout from './app-layout'
import Loading from 'components/shared-components/Loading'
import { RefreshProvider } from './RefreshContext'

const AppLayoutOutlet = () => (
  <RefreshProvider>
    <AppLayout>
      <Suspense fallback={<Loading cover="content" />}>
        <Outlet />
      </Suspense>
    </AppLayout>
  </RefreshProvider>
)

export default AppLayoutOutlet
